var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 0C6.55223 0 6.16865 0.264378 6.00616 0.640965L0.161959 10.4073V10.4083C0.0564857 10.5729 0.000405009 10.7628 0 10.9565C0 11.2333 0.113461 11.4987 0.315423 11.6944C0.517386 11.8901 0.791305 12 1.07692 12C1.10219 11.9998 1.12745 11.9988 1.15264 11.9969L1.15475 12H7H12.8453L12.8474 11.9959C12.8725 11.9981 12.8978 11.9995 12.9231 12C13.2087 12 13.4826 11.8901 13.6846 11.6944C13.8865 11.4987 14 11.2333 14 10.9565C13.9998 10.7624 13.9437 10.5722 13.838 10.4073L13.8296 10.393L13.8286 10.392L7.99384 0.640965C7.83135 0.264378 7.44777 0 7 0ZM6.00616 3.5H7.99384L7.71935 7.73845H6.28906L6.00616 3.5ZM7.0021 8.77072C7.44472 8.77072 7.70989 9.00147 7.70989 9.39538C7.70989 9.78199 7.44472 10.0119 7.0021 10.0119C6.55626 10.0119 6.28906 9.78199 6.28906 9.39538C6.28906 9.00147 6.55572 8.77072 7.0021 8.77072Z",
    fill: "#FF9747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.947c5397918b180641d199a6e61e00a2.svg";
export { ForwardRef as ReactComponent };